import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Register from "./Register";
import Login from "./Login";
import CreateProfile from "./createprofile";
import ViewProfile from "./viewprofile";
import EditProfile from './Editprofile';
import Home from "./Home";

import StuCorners from "./StuCorners";
import ProfilePage from "./profilepage";
import AdminHandle from "./AdminHandle";
import { GoogleOAuthProvider } from "@react-oauth/google";

// Business Page Imports
import CreateBusinessPage from "./CreateBussinessPage";
import BusinessPageView from "./BussinessPageView";
import EditBusinessPage from "./EditBusinessPage"; 
import ChatListPane from "./ChatListPane";
import MessageDisplay from "./MessageDisplay";
import EditGroupInfoSidebar from "./EditGroupInfoSidebar";
import SendDocument from "./sendDocument";
import CreateGroupChat from "./createGroupChat";
import ChatPage from "./messages";
import Notifications from "./notifications";
import MyConnections from "./MyConnections";
import JobsPage from "./JobsPage";
import Dashboard from "./Dashboard";
import BusinessView from "./BusinessView";
import BusinessList from './BusinessList';
import AvaamiConnectApp from "./Landing";
import Feedback from "./feedback";
import PrivacyPolicy from "./privacypolicy";
import UserGuideline from "./userguideline";
import CancellationRefund from "./cancellation";
import ContactUs from "./contactus";

function App() {
  return (
    <GoogleOAuthProvider clientId="795197653117-jk9kb46j3quflsm5q9eebbq1jf9oblsd.apps.googleusercontent.com">
      <Router>
        <Routes>
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/createprofile" element={<CreateProfile />} />
          {/* Change: username to fullName for profile routing */}
          <Route path="/profile/:fullName" element={<ViewProfile />} />
          <Route path="/Editprofile" element={<EditProfile />} />
          <Route path="/Home" element={<Home />} />
          
          {/* Mapping the clean URL path "/people" to the existing component layout */}
          <Route path="/people" element={<BusinessList />} />
          <Route path="/StuCorners" element={<StuCorners />} />
          
          <Route path="/profileview/:userId" element={<ProfilePage />} />
          <Route path="/adminhandle" element={<AdminHandle />} />
          <Route path="/my-connections" element={<MyConnections />} />
          
          {/* --- Business Page Routes --- */}
          <Route path="/CreateBussinessPage" element={<CreateBusinessPage />} />
          
          {/* Business View Page - Updated: Changed :id to :businessName */}
          <Route path="/business/:businessName" element={<BusinessPageView />} />
          <Route path="/business-view/:businessName" element={<BusinessView />} />
         
          <Route path="/edit-business/:id" element={<EditBusinessPage />} />
          <Route path="/" element={<AvaamiConnectApp />} />
          <Route path="/createGroupChat" element={<CreateGroupChat />} />
          <Route path="/ChatListPane" element={<ChatListPane />} />
          <Route path="/sendDocument" element={<SendDocument />} />
          <Route path="/messageDisplay" element={<MessageDisplay />} />
          <Route path="/EditGroupInfoSidebar" element={<EditGroupInfoSidebar />} />
          <Route path="/messages" element={<ChatPage />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/JobsPage" element={<JobsPage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/BusinessList" element={<BusinessList />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/userguideline" element={<UserGuideline />} />
          <Route path="/cancellation" element={<CancellationRefund />} />
          <Route path="/contactus" element={<ContactUs />} />
        </Routes>
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;